module.exports = __webpack_public_path__ + "img/logo-circle.a57592af.png";